import { animate, stagger, utils } from "animejs";
import { rem } from "./ultil";

export const animateComponent = {
	shakingAnimation: () => {
		animate(utils.$("#fixed-tool li:not(.scrollToTop) .icon img"), {
			rotate: [0, 45, -15, 15, 0],
			duration: 600,
			loop: true,
			delay: stagger(600),
			ease: "linear",
		});
	},
	init: () => {
		// animateComponent.shakingAnimation();
	},
};
